











































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import VueRouter from 'vue-router'
import GlobalMixin, {ALERT_TYPE, VIEW_MODE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import CustomerSelectDialogComponent from '@/components/CustomerSelectDialogComponent.vue'
import DatePickerComponent from '@/components/DatePickerComponent.vue'
import SelectTermComponent from '@/components/SelectTermComponent.vue'
import PdfViewComponent from '@/components/PdfViewComponent.vue'
import { TotalInvoice } from '@/domain/TotalInvoice'
import { CustomerInfo } from '@/domain/CustomerInfo'
import { Customer } from '@/domain/Customer'
import { User } from '@/domain/User'
import TotalInvoicesService, { SerchConditon } from '@/service/TotalInvoicesService'
import InvoicesService from '@/service/InvoicesService'
import NumberIssuingService from '@/service/NumberIssuingService'


Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
])

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    CustomerSelectDialogComponent,
    DatePickerComponent,
    SelectTermComponent,
    PdfViewComponent,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const totalInvoicesService = TotalInvoicesService.instance
      if (to.params["no"] === undefined) {
        /* 新規 */
        vm.$data.viewMode = VIEW_MODE.NEW
        totalInvoicesService.createNew().then(x => vm.$data.dto = x)
      } else {
        /* 編集 */
        vm.$data.viewMode = VIEW_MODE.VIEW
        totalInvoicesService.edit(to.params["no"]).then(x => vm.$data.dto = x)
      }
    })
  },
})
export default class MemberTotalInvoiceEdit extends Mixins(GlobalMixin) {
  numberIssuingService = NumberIssuingService.instance
  totalInvoicesService = TotalInvoicesService.instance
  invoicesService = InvoicesService.instance

  dto = new TotalInvoice()
  originalDto = this.dto.clone()
  totalAmount = "0"

  /* 作成者、承認者リスト */
  users: User[] = []
  authorityUsers: User[] = []

  /** 検索条件 */
  conditions = new SerchConditon()
  /** データテーブル ヘッダー設定 */
  searchFilter = ""
  headers = [
          { text: "請求日", value: "invoiceOn", width: "100px" },
          { text: "請求番号", value: "invoiceNo", width: "130px" },
          { text: "受付番号", value: "requestNos", width: "130px" },
          { text: "顧客名", value: "customerInfo.customerName", width: "240px" },
          { text: "検査項目", value: "sumInfo.inspectionNames" },
          { text: "小計", value: "sumInfo.amount", align: "end", width: "100px" },
          { text: "消費税", value: "sumInfo.tax", align: "end", filterable: false, width: "100px" },
          { text: "請求金額", value: "sumInfo.totalAmount", align: "end", filterable: false, width: "100px" },
          { text: "印刷", value: "printAt", align: "center", filterable: false, width: "80px" },
          { text: "メール", value: "mailSendAt", align: "center", filterable: false, width: "100px" },
          { text: "操作", value: "actions", filterable: false, sortable: false, width: "80px" },
  ]
  customerInfo = new CustomerInfo()
  customer = new Customer()
  customerName = ""

  /**
   * 初期実行
   */
  mounted() {
    this.usersService.findByOccupationCode(1)
      .then((x) => {
        this.users = x
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.users = []
      })
    this.usersService.findByAuthorityCode(4)
      .then((x) => {
        this.authorityUsers = x
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.authorityUsers = []
      })
  }

  /**
   * 画面を遷移する前のチェック
   */
  // eslint-disable-next-line
  beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    if (!this.isView) {
      this.confirm("このページから移動しますか？入力中のデータは保存されません").then(res => {
        res === true ? next() : next(false)
      })
    } else {
      next()
    }
  }
  
  /**
   * 編集モードに切り替える
   */
  onEdit() {
    if (this.dto.isPrinted || this.dto.isMailSended) {
      this.confirm("既に印刷またはメール送信していますが、本当に編集してよろしいですか？").then(res => {
        if (res === true) {
          this.viewMode = VIEW_MODE.EDIT
        }
      })
    } else {
      this.viewMode = VIEW_MODE.EDIT
    }
    this.originalDto = this.dto.clone()
  }

  /**
   * 削除
   */
  onDelete() {
    this.confirm("本当に削除してよろしいですか？").then(res => {
      if (res === true) {
        this.showLoading()
        this.totalInvoicesService.delete(this.dto.totalInvoiceNo)
          .then(() => {
            this.viewMode = VIEW_MODE.DELETED
            this.alert("削除しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("削除に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
      }
    })
  }

  /**
   * 編集取消
   */
  onReset() {
    this.confirm("本当に編集を取り消してよろしいですか？").then(res => {
      if (res === true) {
        this.dto = this.originalDto
        this.viewMode =  VIEW_MODE.VIEW
      }
    })
  }

  /**
   * 登録ボタンのクリック
   */
  onSubmit(event: Event) {
    if ((this.$refs.observer as Vue & { validate: () => boolean }).validate()) {
      if (this.viewMode === VIEW_MODE.NEW) {
        /* 登録 */
        this.numberIssuingService.next(NumberIssuingService.TOTAL_INVOICE, this.dto.totalInvoiceOn)
          .then(no => {
            this.dto.totalInvoiceNo = no
            this.save()
          })
          .catch(error => {
            // eslint-disable-next-line
            console.log(error)
          })
      } else {
        /* 更新 */
        if (this.dto.isPrinted || this.dto.isMailSended) {
          this.confirm("印刷およびメール送信情報は、消去されますがよろしいですか？").then(res => {
            if (res === true) {
              this.save()
            } else {
              event.stopPropagation()
            }
          })
        } else {
          this.save()
        }
      }
    } else {
      event.stopPropagation()
    }
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    this.conditions.totalInvoiceNo = this.dto.totalInvoiceNo
    this.totalInvoicesService.findTarget(this.conditions)
      .then(x => {
        this.dto.invoices = x
        this.dto.startOn = this.conditions.startOn
        this.dto.endOn = this.conditions.endOn
        this.dto.totalInvoiceOn = this.conditions.endOn
        this.dto.customerInfo = this.customerInfo
        this.calcTotalAmount()
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * 作成者の変更
   */
  onChangeAuthor(event: User) {
    this.dto.authorUser.userId = event.userId
    this.dto.authorUser.userName = event.userName
  }

  /**
   * 請求を削除
   */
  deleteLine(invoiceNo: string) {
    this.confirm("明細行を削除してよろしいですか？").then(res => {
      if (res === true) {
        this.dto.invoices = this.dto.invoices.filter(x => x.invoiceNo !== invoiceNo)
        this.calcTotalAmount()
      }
    })
  }

  /**
   * 承認者の変更
   */
  onChangeAuthorizer(event: User) {
    this.dto.authorizerUser.userId = event.userId
    this.dto.authorizerUser.userName = event.userName
  }

  /**
   * オートコンプリートフィルター
   */
  // eslint-disable-next-line
  usersFilter(item: User, queryText: string, itemText: string) {
    return item.userName.toLowerCase().indexOf(queryText.toLowerCase()) >= 0
  }

  /**
   * 印刷ボタンのクリック
   */
  onPrint() {
    this.totalInvoicesService.print(this.dto.totalInvoiceNo)
      .then(dto => {
        this.dto = dto
        this.openPdfViewDialog("合算請求書印刷", dto.totalInvoiceFile.content)
      })
  }

  /**
   * 顧客選択ダイアログの表示
   */
  openCustomerSelectDialog() {
    this.customerSelectDialog = true
  }

  /**
   * 顧客選択クリア
   */
  clearCustomer() {
    this.conditions.customerPrefectureCode = ""
    this.conditions.customerCode = ""
    this.conditions.customerBranchNumber = ""
    this.customerName = ""
    this.customerInfo = new CustomerInfo()
    this.customer = new Customer()
    this.dto.invoices = []
    this.dto.customerInfo = new CustomerInfo()
  }

  /**
   * 顧客選択
   */
  onCustomerSelected(event: CustomerInfo) {
    this.conditions.customerPrefectureCode = event.customerPrefectureCode
    this.conditions.customerCode = event.customerCode
    this.conditions.customerBranchNumber = event.customerBranchNumber
    this.customerName = event.customerName
    this.customerInfo = event
    this.customersService.show(this.conditions.customerPrefectureCode, this.conditions.customerCode, this.conditions.customerBranchNumber)
      .then(x => this.customer = x)
  }

  /**
   * 合計金額の集計
   */
  calcTotalAmount() {
    this.totalAmount = (this.dto.invoices.map(x => x.sumInfo.amount).reduce((p, a) => p + a, 0)).toLocaleString()
  }

  /**
   * データの保存
   */
  private save() {
    this.showLoading()
    this.invoicesService.getDetails(this.dto.invoices.map(x => x.invoiceNo))
      .then(details => {
        this.dto.details = details
        this.dto.sum()
        this.pdfService.generateTotalInvoice(this.dto)
          .then(pdf => {
            this.dto.totalInvoiceFile = pdf
            this.dto.printAt = null
            this.dto.mailSendAt = null

            if (this.isNew) {
              this.totalInvoicesService.create(this.dto)
                .then((x) => {
                  this.dto = x
                  this.viewMode = VIEW_MODE.VIEW
                  this.alert("保存しました", ALERT_TYPE.SUCCESS)
                  this.hideLoading()
                })
                .catch((error) => {
                  // eslint-disable-next-line
                  console.log(error)
                  this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
                  this.hideLoading()
                })
            } else {
              this.totalInvoicesService.update(this.dto)
                .then((x) => {
                  this.dto = x
                  this.viewMode = VIEW_MODE.VIEW
                  this.alert("保存しました", ALERT_TYPE.SUCCESS)
                  this.hideLoading()
                })
                .catch((error) => {
                  // eslint-disable-next-line
                  console.log(error)
                  this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
                  this.hideLoading()
                })
            }
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * 初期化処理
   */
  @Watch("dto")
  changeDto() {
    /* 初期化処理 */
    if (this.viewMode === VIEW_MODE.NEW) {
      /* 作成者 */
      const authorUser = this.users.find(x => x.userId === this.loginUserId)
      if (authorUser !== undefined) {
        this.dto.authorUser.userId = authorUser.userId
        this.dto.authorUser.userName = authorUser.userName
      }
    } else {
        this.conditions.customerPrefectureCode = this.dto.customerInfo.customerPrefectureCode
        this.conditions.customerCode = this.dto.customerInfo.customerCode
        this.conditions.customerBranchNumber = this.dto.customerInfo.customerBranchNumber
        this.conditions.startOn = this.dto.startOn
        this.conditions.endOn = this.dto.endOn
        this.customerInfo = this.dto.customerInfo
        this.customerName = this.dto.customerInfo.customerName
        this.calcTotalAmount()
    }
  }

}
